import React from 'react'
import {BrowserRouter ,Routes , Route} from 'react-router-dom';
import Register from './pages/Register';
import Login from './pages/Login';
import Chat from './pages/Chat';
import NavBar from './components/NavBar';
import SetAvatar from './pages/SetAvatar';
import NotFound404 from './pages/NotFound404';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<NavBar/>}>
            <Route index element={<Chat/>}/>
            <Route path='/register' element={<Register/>}/>
            <Route path='/login' element={<Login/>}/>
            <Route path='/setavatar' element={<SetAvatar/>}/>
            </Route>
            <Route path='*' element={<NotFound404/>}/>
          </Routes>
        </BrowserRouter>
    </>
  )
}

export default App